import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';
import { ValueAdapter } from '../../value.adapter';
import { GoogleBigQueryV2CopySink } from 'app/model/pipeline/copysink/google-bigquery-v2.copysink';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleBigQueryV2CopySink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBatchTimeout: '*',
        writeBatchSize: '*',
        preCopyScript: '*',
        writeBehavior: '*'
    }
})
export class GoogleBigQueryV2SinkAdapter extends CopySinkAdapter<GoogleBigQueryV2CopySink, Model.GoogleBigQueryV2Sink> {
    protected override async _toResource(model: GoogleBigQueryV2CopySink): Promise<Model.GoogleBigQueryV2Sink> {
        const result: Model.GoogleBigQueryV2Sink = {
            type: 'GoogleBigQuerySink'
        };
        TabularSinkAdapter.toSinkResource(model, result);
        result.writeBehavior = ValueAdapter.toResource(model, GoogleBigQueryV2CopySink.WRITE_BEHAVIOR);;
        return result;
    }

    protected override async _toModel(resource: Model.GoogleBigQueryV2Sink, owner: Activity): Promise<GoogleBigQueryV2CopySink> {
        const result = Owned.create<GoogleBigQueryV2CopySink>(Metamodel.modelFor(GoogleBigQueryV2CopySink), owner);
        TabularSinkAdapter.toSinkModel(resource, result);
        ValueAdapter.toModel(result, GoogleBigQueryV2CopySink.WRITE_BEHAVIOR, resource.writeBehavior);
        return result;
    }
}
